import React from 'react';
import { handleActions } from 'redux-actions';
import { set as setPath, toPath, merge } from 'lodash';
import * as ActionTypes from '../../../constants/ActionTypes';

const headerDataReducer = handleActions(
    {
        [ActionTypes.THEME_MODIFY_KEY]: (state, action) => {
            let pathCheck = action.path.split('.');
            if (pathCheck[0] === 'header') {
                pathCheck.shift();
                return merge({}, state, setPath({}, pathCheck, action.value));
            } else {
                return state;
            }
        },
        [ActionTypes.LOGIN_SET_THEME]: (state, action) => {
            if (
                action.theme.hasOwnProperty('header') ||
                action.theme.hasOwnProperty('heroImage') ||
                action.theme.hasOwnProperty('progressIndicator') ||
                action.theme.hasOwnProperty('landingPage')
            ) {
                return {
                    ...state,
                    ...action.theme.header,
                    heroImage: action.theme.heroImage,
                    progressIndicator: action.theme.progressIndicator,
                    landingPage: action.theme.landingPage
                };
            }
            return state;
        },
        [ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_SIZE]: (state, action) => {
            let obj = {
                hamburgerMenu: {
                    ...state.hamburgerMenu
                }
            };
            obj['hamburgerMenu'] = { ...state['hamburgerMenu'], iconSize: action.size };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_WEIGHT]: (state, action) => {
            let obj = {
                hamburgerMenu: {
                    ...state.hamburgerMenu
                }
            };
            obj['hamburgerMenu'] = { ...state['hamburgerMenu'], width: action.weight };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_FONT_COLOR]: (state, action) => {
            let obj = {
                hamburgerMenu: {
                    ...state.hamburgerMenu
                }
            };
            obj['hamburgerMenu']['color'] = { ...state['hamburgerMenu']['color'], normal: action.color };
            return { ...state, ...obj };
        },
        [ActionTypes.THEME_HEADER_HAMBURGER_SET_THEME_BACKGROUND_COLOR]: (state, action) => {
            let obj = {
                hamburgerMenu: {
                    ...state.hamburgerMenu
                }
            };
            obj['hamburgerMenu']['background'] = { ...state['hamburgerMenu']['background'], normal: action.background };
            return { ...state, ...obj };
        }
    },
    {}
);

export default headerDataReducer;



// WEBPACK FOOTER //
// ./src/reducers/theme/data/header.js